"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeComments;

var _constants = require("../constants");

function removeComments(node) {
  _constants.COMMENT_KEYS.forEach(function (key) {
    node[key] = null;
  });

  return node;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/types/lib/comments/removeComments.js
// module id = hlvQ
// module chunks = 0